import React from 'react'
import { indexOf, lastIndexOf } from 'lodash/array'
import { sortBy } from 'lodash/collection'
import { Button } from 'semantic-ui-react'

import { token } from 'utils/csrf'

import LotNumberItem from './LotNumbers/LotNumberItem'

class LotNumbers extends React.PureComponent {
  componentWillMount () {
    this.setState({
      submitting: false,
      placements: this.props.placements,
    })
  }

  sortPlacements (placements) {
    return sortBy(placements, ['lot_number'])
  }

  onItemUpdate (lot_number, id) {
    const placements = this.sortPlacements(
      this.state.placements.map((placement) => {
        if (placement.id !== id) return placement
        return {
          ...placement,
          lot_number,
        }
      })
    )

    this.setState({
      ...this.state,
      placements,
    })
  }

  placementsShowingDuplicates () {
    const placements = this.state.placements
    const lotNumbers = placements.map((placement) => placement.lot_number)
    let duplicates = []

    const marked = placements.map((placement) => {
      const duplicate = indexOf(lotNumbers, placement.lot_number) !== lastIndexOf(lotNumbers, placement.lot_number)
      if (duplicate && duplicates.indexOf(placement.lot_number) === -1) {
        duplicates.push(placement.lot_number)
      }

      return {
        ...placement,
        duplicate,
      }
    })

    return {
      placements: marked,
      duplicates,
    }
  }

  onSubmit () {
    this.setState({
      ...this.state,
      submitting: true,
    })
  }

  render () {
    const { placements, duplicates } = this.placementsShowingDuplicates()

    return (
      <form
        action={this.props.sort_url}
        className='ui index-items'
        method='POST'
        onSubmit={() => this.onSubmit()}
      >
        {placements.map((placement) => (
          <LotNumberItem
            placement={placement}
            key={placement.id}
            onChange={(lot_number, id) => this.onItemUpdate(lot_number, id)}
          />
        ))}

        {this.state.submitting && (
          <div className='ui active inverted dimmer'>
            <div className='ui text loader'>Ukládám</div>
          </div>
        )}

        <input type='hidden' name="authenticity_token" value={token} />
        <input type='hidden' name="auction_id" value={this.props.auction_id} />

        <div className='ui index-items-actions clearfix'>
          {duplicates.length > 0 && (
            <p className='red text'>Duplicitní čísla: {duplicates.join(', ')}</p>
          )}

          <Button primary type='submit'>Uložit</Button>
        </div>
      </form>
    )
  }
}

export default LotNumbers



// WEBPACK FOOTER //
// ./app/javascript/components/LotNumbers.js